import React, { type ReactNode, type ComponentType } from 'react';
import { Spotlight } from '@atlaskit/onboarding';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

type SpotlightProps = typeof Spotlight extends ComponentType<infer TProps> ? TProps : unknown;

interface Props {
	target: string;
	actionsBeforeElement: ReactNode;
	headingAfterElement: ReactNode;
	actions: (arg0: { learnMoreURL: string }) => SpotlightProps['actions'];
}

export const ListModeSpotlight = ({
	target,
	actionsBeforeElement,
	headingAfterElement,
	actions,
}: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			target={target}
			targetBgColor={token('elevation.surface', colors.N0)}
			dialogPlacement="bottom right"
			actionsBeforeElement={actionsBeforeElement}
			actions={actions({ learnMoreURL: '' })}
			headingAfterElement={headingAfterElement}
			heading={ff('sploverview-onboarding-tour') ? formatMessage(messages.heading) : undefined}
		>
			{ff('sploverview-onboarding-tour') ? (
				// Needed the div to fix the word break from flex container
				// eslint-disable-next-line jira/react/no-empty-divs
				<div>
					{formatMessage(messages.description, {
						b: (...chunks: ReactNode[]) => <strong>{chunks}</strong>,
					})}
				</div>
			) : (
				<FormattedMessage {...messages.content} />
			)}
		</Spotlight>
	);
};
